












export default
	name: 'faqListing'

	props: block: Object

	computed:

		faqAccordionBlock: -> {
			layout: "full"
			textAlignment: "left"
			accordionPanes: @block.faqs.map (faq, idx) -> {
				title: faq.title
				# Panes builds a block list for each, create a copy block per answer
				blocks:[
					{
						__typename: "blocks_copy_BlockType"
						body: faq.answer
						unorphan: true
					}
				]
			}
		}

